import { keepPreviousData, useQuery } from "@tanstack/react-query";

import {
  ISamMedication,
  ISamMedicationsFilters,
  ISamMedicationSummary,
} from "../../../@types/admin/AdminMedication";
import { IPaginatedResponse } from "../../../@types/PaginatedResponse";
import { samMedicationsService } from "../../../services/admin";
import { ensureOk } from "../../../utils/ensureOk";

export const SAM_MEDICATIONS_QUERY_KEY = "admin-sam-medications";
export const SAM_MEDICATIONS_SUMMARY_QUERY_KEY =
  "admin-sam-medications-summary";

/** A page of SAM packs (EN-5240). Server-paginated and server-sorted. */
export function useSamMedications(filters: ISamMedicationsFilters) {
  const { data, isLoading, isFetching, isError } = useQuery<
    IPaginatedResponse<ISamMedication[]>
  >({
    queryKey: [SAM_MEDICATIONS_QUERY_KEY, filters],
    queryFn: async () =>
      ensureOk(await samMedicationsService.getMedications(filters)),
    placeholderData: keepPreviousData,
    refetchOnMount: "always",
  });

  return {
    medications: data?.result ?? [],
    totalCount: data?.totalCount ?? 0,
    isLoading,
    isFetching,
    isError,
  };
}

/** Counts and seeded releases shown above the list. */
export function useSamMedicationSummary() {
  const { data, isLoading, isError } = useQuery<ISamMedicationSummary>({
    queryKey: [SAM_MEDICATIONS_SUMMARY_QUERY_KEY],
    queryFn: async () => ensureOk(await samMedicationsService.getSummary()),
    refetchOnMount: "always",
  });

  return { summary: data, isLoading, isError };
}
